import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { useContext } from 'react';
import { useDownload } from '@europrocurement/l2d-modules/hooks';
import { DocumentPreviewContext } from '../../../providers';
import DocumentViewer from '../DocumentViewer/DocumentViewer';
import DocumentPreviewHeader from '../DocumentPreviewHeader/DocumentPreviewHeader';
import DocumentPreviewFooter from '../DocumentPreviewFooter/DocumentPreviewFooter';
import useDossierDocumentFilesApi from '../../../hooks/useDossierDocumentFilesApi';

type DocumentPreviewOverlayProps = {
    sxProps?: object;
};

const DocumentPreviewOverlay: React.FunctionComponent<DocumentPreviewOverlayProps> = function ({
    sxProps,
}) {
    const { palette, breakpoints } = useTheme();
    const downMd = useMediaQuery(breakpoints.down('md'));
    const { documentPreview, setDocumentPreview } = useContext(DocumentPreviewContext);
    const { download } = useDownload();
    const { getFileIcon } = useDossierDocumentFilesApi();

    if (!documentPreview) {
        return null;
    }

    const { fileName, fileType, content } = documentPreview;

    const handleClose = () => {
        setDocumentPreview(undefined);
    };

    const handleDownload = () => {
        download(fileName, content);
    };

    const contentSx = {
        margin: '0 30px',
        border: `solid 1px ${palette.grey[300]}`,
        boxShadow: `0px 2px 2.5px 0px ${palette.grey[300]}`,
        height: '80%',
        borderRadius: '6px',
        overflow: 'hidden',
    };

    return (
        <Box // Wrapper
            onClick={handleClose}
            sx={{ width: '100%', height: '100%', position: 'fixed', top: 0, left: 0 }}
        >
            <Box
                onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
                sx={{
                    position: 'fixed',
                    top: '0',
                    right: '0',
                    maxWidth: downMd ? '100%' : '50%',
                    width: '100%',
                    height: '100vh',
                    background: palette.background.paper,
                    boxShadow: `1px 1px 15px 0px ${palette.grey[200]}`,
                    borderRadius: '12px',
                    zIndex: 1150,
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: '72px',
                    ...sxProps,
                }}
            >
                <DocumentPreviewHeader
                    fileName={fileName}
                    onClose={handleClose}
                    fileIcon={fileType ? getFileIcon(fileType) : 'file'}
                />
                <Box sx={contentSx}>
                    <DocumentViewer />
                </Box>
                <DocumentPreviewFooter onDownload={handleDownload} />
            </Box>
        </Box>
    );
};

export default DocumentPreviewOverlay;
